import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import ReactLink from '@material-ui/core/Link';
import cx from 'classnames';
import { makeStyles } from '../../theme';
import Box from '../layout/box';
import Text from '../../core/text';
import { ChevronRight } from '../icons';
import * as componentStyling from '../styling';
import { useRouting } from '../../../routes';

/**
 * Use `theme settings` as much as possible instead of hard-coded values.
 * More theme settings on: https://material-ui.com/customization/theming/
 */
const linkStyles = makeStyles(
    ({ palette, spacing }) => ({
        link: {
            cursor: 'pointer',
            marginBottom: spacing(2.5),

            '&:focus':{
                outline: `5px auto ${palette.action.focus}`
            }
        }
    })
)

const Link = React.memo(({ className, ...props }) => {
	const classes = linkStyles();
	const routingEnabled = useRouting();
    const { href } = props;



	const routerLinkProps = routingEnabled 
		? href && !/^https?:/.test(href) && {
			to: href,
			component: RouterLink
		} 
		: {};

	return (
        <ReactLink {...props} className={cx(classes.link, className)} {...routerLinkProps} />
	);
});

export default Link;

/**
 * Use `theme settings` as much as possible instead of hard-coded values.
 * More theme settings on: https://material-ui.com/customization/theming/
 */
const linkListStyles = makeStyles(
    ({ spacing }) => ({
        list:{
            padding: 0,
            listStyleType: 'none',
            marginBottom: spacing(2.5),

            '& > li': {
                marginBottom: spacing(1)
            }
        },
        listItem:{
            marginBottom: spacing(0.625)
        }
    })
);

export const LinkList = React.memo(({ children }) => {
	const classes = linkListStyles();
    const childArr = React.Children.toArray(children);

	return (
        <ul className={cx(classes.list, componentStyling.Control)}>
            {childArr.map((child,i) => (
                <li key={`listitem-${i}`} className={cx(classes.listItem)}>{child}</li>
            ))}
        </ul>
    );
});


/**
 * Use `theme settings` as much as possible instead of hard-coded values.
 * More theme settings on: https://material-ui.com/customization/theming/
 */
const navLinkStyles = makeStyles(
    ({ spacing, shape, palette }) => ({
        navLink: {
            width:'100%',
			color: palette.text.link,
            '& > div': {
                padding: spacing(1.625),
                borderRadius: shape.borderRadius * 2,
                boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.16)'
            }
		},
		label:{
			textAlign:'left !important'
		}
    })
);

export const NavLink = React.memo(({ className, children, ...rest }) => {
	const classes = navLinkStyles();

    return (
        <Link className={cx(classes.navLink, componentStyling.Control)} underline="none" {...rest}>
			<Box type="HORIZONTAL" justifyContent="space-between">
				<Text component="span" className={cx(classes.label)}>{children}</Text>
				<ChevronRight />
			</Box>
		</Link>
    );
});

export const NavLinks = React.memo(({ options, onLinkClick, autoFocus, ...props }) => {
    return (
        <LinkList {...props}>
            {options.map(
                ({ label, ...rest }, i) => (
                    <NavLink
                        underline="none"
                        key={`navlinks-${i}`}
                        autoFocus={autoFocus && i===0}
                        {...rest}
                        onClick={onLinkClick(rest)}
                        >
                        {label}
                    </NavLink>
                )
            )}
        </LinkList>
    );
});